import { SelectableInfo } from '../enums/Enum';
import { makeArray } from './Model';
import { ProgramExtensionStatus } from './ProgramExtensionStatus';

export class ProgramExtension {
  id = 0;

  name = '';

  abbr = '';

  program = false;

  statuses: ProgramExtensionStatus[] = [];

  constructor(obj: any) {
    Object.assign(this, obj);
    this.statuses = makeArray(obj.statuses, ProgramExtensionStatus)?.sort(
      ProgramExtensionStatus.sort,
    );
  }

  static CCM = 2;

  static RPM = 3;

  static VESTA_CORE = 5;

  static VESTA_LITE = 9;

  static TCM = 42;

  static MEDICAID = 43;

  static SKILLED = 109;

  static BHI = 110;

  static VPC = 142;

  static GUIDE = 175;

  static toSelectable(
    pe: ProgramExtension[],
  ): SelectableInfo<ProgramExtension>[] {
    return pe.map((item) => ({
      value: item.id,
      label: item.name,
      info: item,
    }));
  }

  static sort({ abbr: a }: ProgramExtension, { abbr: b }: ProgramExtension) {
    return a.localeCompare(b);
  }
}

export default ProgramExtension;
